<div class="forms-page">
  <div class="constrainer">
    <ng-container *ngIf="loading">
      <div class="loading">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner"
          strokeWidth="4"></p-progressSpinner>
      </div>
    </ng-container>

    <div class="filters">
      <form-filter></form-filter>
    </div>

    <div class="header">
      <button pButton [label]="'forms.pages.forms.new_form' | translate" class="p-button-secondary" (click)="newForm()"></button>
    </div>

    <div class="forms-list">
      <div class="headings">
        <div class="name">{{'forms.pages.forms.name' | translate}}</div>
        <div class="take-payment">{{'forms.pages.forms.take_payment' | translate}}</div>
        <div class="status">{{'forms.pages.forms.status' | translate}}</div>
        <div class="actions"></div>
      </div>
      <ng-container *ngFor="let form of forms">
        <div class="form-list-item">
          <form-list-item [form]="form"></form-list-item>
        </div>
      </ng-container>
      <ng-container *ngIf="(forms && forms.length === 0) && !isLoading">
        <div class="no-results">
          <h1> {{'forms.pages.forms.forms_matching_filter' | translate}} </h1>
          <h2>{{'forms.pages.forms.try_following' | translate}}</h2>
          <ul>
            <li>{{'forms.pages.forms.search_term' | translate}}</li>
            <li>{{'forms.pages.forms.status_filter' | translate}}</li>
            <li>{{'forms.pages.forms.payment_filter' | translate}}</li>
          </ul>
        </div>
      </ng-container>
    </div>
  </div>
</div>
